import type { TimeZoneOption } from '@/types/serializers'

export type ListboxKey = 'ArrowDown' | 'ArrowUp' | 'Home' | 'End'

export function groupByRegion(zones: TimeZoneOption[]): Array<[string, TimeZoneOption[]]> {
  const groups = new Map<string, TimeZoneOption[]>()
  for (const zone of zones) {
    const group = groups.get(zone.region_label)
    if (group) group.push(zone)
    else groups.set(zone.region_label, [zone])
  }
  return [...groups]
}

export function isListboxKey(key: string): key is ListboxKey {
  return key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End'
}

export function moveHighlight(
  values: readonly string[],
  current: string | null,
  key: ListboxKey,
): string | null {
  if (values.length === 0) return null
  if (key === 'Home') return values[0] ?? null
  if (key === 'End') return values[values.length - 1] ?? null

  const index = current === null ? -1 : values.indexOf(current)
  if (key === 'ArrowDown')
    return values[index < 0 ? 0 : Math.min(index + 1, values.length - 1)] ?? null
  return values[index < 0 ? values.length - 1 : Math.max(index - 1, 0)] ?? null
}

export function zoneName(zone: Pick<TimeZoneOption, 'region_label' | 'label' | 'offset_label'>) {
  return `${zone.region_label} · ${zone.label} (${zone.offset_label})`
}

export function zoneQuestion(template: string, zone: TimeZoneOption): string {
  return template.replace('%{zone}', zoneName(zone))
}
